import ForgottenAuth from './ForgottenAuth'

export default ForgottenAuth
